import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { Copil } from '@apps/pata/domain/models/copil';
import { DetailedCopil } from '@apps/pata/domain/models/detailed-copil';

export const PataCopilFeatureKey = 'copils';

type ICopilState = EntityState<Copil>;
export const copilsAdapter: EntityAdapter<Copil> = createEntityAdapter({
    selectId: (copil: Copil) => copil.copilId
});
const copilsInitialState: ICopilState = copilsAdapter.getInitialState({});

export interface IPataCopilsState {
    copils: ICopilState;
    selectedCopil: DetailedCopil;
    isLoading: boolean;
    isLoaded: boolean;
    isEmpty: boolean;
    isOups: boolean;
    doneFilter?: boolean;
    qsWord: string;
}

export const PataCopilsInitialState: IPataCopilsState = {
    copils: copilsInitialState,
    selectedCopil: null,
    isLoading: false,
    isLoaded: false,
    isEmpty: false,
    isOups: false,
    doneFilter: null,
    qsWord: ''
};
